
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component
export default class extends Vue {
  @Prop() private clickUs!: boolean
  private visible = true

  @Watch('clickUs', { deep: true, immediate: true })
  handleWatch (val: boolean) {
    this.visible = val
  }

  hanlderEnter (): void {
    this.$emit('hanlderDialog')
  }
}
